const hobbySuggestions = [
  '',
]

export default hobbySuggestions